import DatePicker from "react-datepicker";
import moment from "moment";

const DatePickerField = ({
    isBlink,
    name,
    formate,
    value,
    handleChange,
    isDisabled,
    minDate,
    maxDate,
    isMonthDropdown,
    isYearDropdown,
    isMonth
}) => {
  return (
    <DatePicker
      className={`monthDate ${isBlink ? "month_blink active" : ""}`}
      dateFormat={formate}
      showMonthYearPicker={isMonth}
      name={name}
      onChange={(date) => {
        let dateTime = date
        if(isMonth){
            dateTime = moment(date).format("yyyy-MM");
        }
        
        handleChange(dateTime)
      }}
      disabled={isDisabled}
      selected={value ? new Date(moment(value)) : ""}
      showMonthDropdown={isMonthDropdown}
      showYearDropdown={isYearDropdown}
      minDate={minDate}
      maxDate={maxDate}
      dropdownMode="select"

    />
  );
};

export default DatePickerField;